// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Backdrop_backdrop__2_G-Y","dark":"Backdrop_dark__164Ty"};